module.exports = __webpack_public_path__ + "static/google-play-badge-eb5ff08d3f576416e68b479c14e011c9.png";